import Vue from 'vue'
import 'lib-flexible/flexible'
import { List, Popup, Toast, Row, Col, Checkbox, Swipe,Tag ,Rate , Progress,
  SwipeItem, Lazyload, Icon, ImagePreview, Collapse, CollapseItem,Uploader,
  Tab, Tabs ,Picker,Dialog ,Button,Step, Steps ,Field,RadioGroup,Radio,Cell,CellGroup,Overlay} from 'vant'
import App from './App.vue'
import router from '@router'
import store from '@store'
import VueClipboard from 'vue-clipboard2'
import zhugeObj from '@/assets/js/track'


import '@components'
import '@plugins'
// import VueAMap from 'vue-amap';
import filters from '@assets/js/filters';

import $ from "jquery";
import 'swiper/dist/css/swiper.css';
//定义过滤器
Object.keys(filters).forEach(element=>{
  Vue.filter(element, filters[element]);
})

import DEFAULT_IMG from '../public/images/public/default.jpg'
import DEFAULT_AVATAR from '../public/images/public/default_avatar.png'

// 图片加载失败时替换图片域名
setTimeout(() => {
  document.addEventListener("error", function(evt){
    try {
      const elem = evt.target
      if (elem.tagName.toLowerCase() === 'img') {
        if(elem.src.indexOf('baozheng-front-new.baozheng.cc') > -1) {
          elem.src = elem.src.replace('baozheng-front-new.baozheng.cc', 'baozheng-front-new.oss-cn-beijing.aliyuncs.com')
        }
      }
    } catch(err){}
  }, true)
}, 200)

Vue.component('van-list', List)
Vue.component('van-popup', Popup)
Vue.component(Checkbox.name, Checkbox)
// Vue.use(VueAMap);

// VueAMap.initAMapApiLoader({
//   key: '8ad6426059ac16db042546b1a6bdf29d',
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
//   // 默认高德 sdk 版本为 1.4.4
//   v: '1.4.4'
// });


// (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
//   (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
//   m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
//   })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

// ga('create', 'UA-142511555-1', 'auto')
// ga('send', 'pageview') // 是否要统计着陆页面访问，取决于你的需求，这个不一定需要，会和`router`统计有重复


Vue.use(Step).use(Steps);
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Toast)
Vue.use(Picker)
Vue.use(Icon)

Vue.use(Row).use(Col)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Lazyload, {})
Vue.use(Collapse).use(CollapseItem)
Vue.use(Tab).use(Tabs)
Vue.use(Field);
Vue.use(Progress);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Cell).use(CellGroup);
Vue.use(Overlay);
Vue.use(VueClipboard);
Vue.use(Tag);
Vue.use(Rate);
Vue.use(Uploader);
Vue.prototype.$imagePreview = ImagePreview
Vue.prototype['DEFAULT_IMG'] = DEFAULT_IMG
Vue.prototype['DEFAULT_AVATAR'] = DEFAULT_AVATAR
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')